<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import Buttons from '@/components/ui/Buttons.vue';
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  description,
  image,
  buttons,
  hasTitle,
  hasDescription,
  hasImage,
  hasButtons,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
      backgroundColor === 'black' ? 'white' : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="maintenance max-w-723">
        <NuxtImg
          v-if="hasImage"
          :src="image.src"
          :alt="image.alt"
          :width="image.width"
          :height="image.height"
          class="maintenance__image"
          data-aos="fade-up"
          data-aos-delay="100"
          loading="lazy"
        />
        <div class="maintenance__bottom">
          <h2
            v-if="hasTitle"
            class="mb-0 maintenance__title h2"
            data-aos="fade-up"
            data-aos-delay="200"
            v-html="title"
          ></h2>
          <div
            v-if="hasDescription"
            class="maintenance__text h2 body-1-regular"
            data-aos="fade-up"
            data-aos-delay="300"
            v-html="description"
          ></div>
          <Buttons
            v-if="hasButtons"
            class="maintenance__buttons"
            :buttons="buttons"
            :background-color="backgroundColor"
            data-aos="fade-up"
            data-aos-delay="400"
            :buttons-prefix-class="'js-button-maintenance'"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.maintenance {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin: 0 auto;
  width: 100%;
  @include media-breakpoint-up(sm) {
    gap: 64px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 64);
  }
  &__title {
    margin: 0;
  }
  &__image {
    height: auto;
    width: 100%;
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    gap: 32px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__text {
    @include media-breakpoint-up(sm) {
      margin: 0 auto;
      max-width: 68%;
    }
  }
  &__buttons {
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 8px;
    @include media-breakpoint-up(sm) {
      gap: 16px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
}
</style>
